<template>
  <a-modal
    :visible="visible"
    wrap-class-name="checkwebdetail-modal"
    :title="config.title"
    :width="config.width"
    :mask-closable="false"
    @cancel="close()"
  >
    <div class="cont">
      <div class="success">
        <svg
          focusable="false"
          data-icon="check-circle"
          width="32px"
          height="32px"
          fill="currentColor"
          aria-hidden="true"
          viewBox="64 64 896 896"
        >
          <path
            d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
          ></path>
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
          ></path>
        </svg>
        <p>网站验证详情</p>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in langset_num" :key="index">
          <p>{{ item.name }}</p>
          <span class="status" :class="`status${item.status}`">
            <svg
              v-if="item.status == '3'"
              focusable="false"
              data-icon="close-circle"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              fill-rule="evenodd"
              viewBox="64 64 896 896"
            >
              <path
                d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
              ></path>
            </svg>
            <svg
              v-if="item.status == '2'"
              focusable="false"
              data-icon="check-circle"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              viewBox="64 64 896 896"
            >
              <path
                d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
              ></path>
              <path
                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
              ></path>
            </svg>
            {{ item.status_text }}
          </span>
        </div>
      </div>
      <p class="btn-box">
        <a-button @click="close()">关闭</a-button>
      </p>
    </div>
  </a-modal>
</template>
<script>
import API from "../api";
import moment from "moment";
import Vue from "vue";

export default {
  name: "Customer",
  data() {
    return {
      visible: false,
      config: {
        title: "网站验证详情",
        width: "430px",
      },
      langset_num: [],
    };
  },
  props: {},
  created() {},
  mounted() {},
  computed: {},
  components: {},
  methods: {
    open(data) {
      this.visible = true;
      this.langset_num = data;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.list {
  margin: 20px 0;
  max-height: 50vh;
  overflow-y: auto;
}
.list::-webkit-scrollbar {
  width: 4px;
  background: white;
}
.list::-webkit-scrollbar-corner,
.list::-webkit-scrollbar-thumb,
.list::-webkit-scrollbar-track {
  border-radius: 4px;
}
.list::-webkit-scrollbar-corner,
.list::-webkit-scrollbar-track {
  background-color: #f2f2f2;
  box-shadow: inset 0 0 1px #f2f2f2;
}
.list::-webkit-scrollbar-thumb {
  background-color: #d7d9dd;
  width: 4px;
}
.list .item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  line-height: 1.3;
}
.list .item p {
  margin: 0;
  flex: 1;
}
.list .item p span {
  color: #1890ff;
  margin-left: 5px;
  cursor: pointer;
}
.list .item .status {
  display: flex;
  align-items: center;
}
.list .item .status svg {
  margin-right: 5px;
}
.success {
  text-align: center;
}
.success svg {
  color: #52c41a;
}
.btn-box {
  text-align: center;
}
</style>
<style>
.checkwebdetail-modal .ant-modal-header {
  display: none;
}
.checkwebdetail-modal .ant-modal-close-x {
  display: none;
}
.checkwebdetail-modal .ant-modal-body {
  padding-bottom: 10px !important;
}
.checkwebdetail-modal .ant-modal-footer {
  display: none;
}
</style>
